import gql from "graphql-tag";

/**
 * Schematics:
 * type
 * type*s
 * clientType
 */



/******************************
 * CLIENT
 ******************************/

export const clientCredentials = gql`
query clientCredentials {
	clientCredentials {
		id @client
		name @client
		avatar @client
	}
}`;



/******************************
 * USER
 ******************************/

export const users = gql`
{
	users {
		id
		name
		avatar
	}
}`;

export const usersLastAction = gql`
{
	usersLastAction {
		id
		name
		avatar
		lastAction
	}
}`;

export const user = gql`
query user($id: ID!) {
  user(id: $id) {
    id
    dateCreated
    name
    lastAction
    email
    avatar
    description
    birthday
    phone
  }
}`;



/******************************
 * CHANNELS
 ******************************/

export const channels = gql`
{
	channels {
		id
		name
	}
}`
export const channelsUnread = gql`
{
	channelsUnread {
		id
		name
		lastView
		unreadCount
	}
}`

export const commentFeed = gql`
query commentFeed($filter: CommentFilter!, $cursor: Date) {
	commentFeed(filter: $filter, cursor: $cursor) {
		cursor
		comments {
			id
			body
			dateCreated
			dateEdited
			user {
				id
				name
				avatar
			}
			votes {
				user {
					id
					name
				}
			}
			children {
				id
				body
				dateCreated
				dateEdited
				user {
					id
					name
					avatar
				}
				votes {
					user {
						id
						name
					}
				}
			}
			files {
				id
				filename
				name
				type
				size
			}
			weblinks {
				id
				url
				title
				type
				image
				descr
				icon
				flags
				alias
			}
		}
	}
}`

export const channel = gql`
query channel($id: ID!) {
	channel(id: $id) {
  		id
		name
	}
}`;



/******************************
 * COMMENTS
 ******************************/

export const comment = gql`
query comment($id: ID!) {
	comment(id: $id) {
		id
		body
		dateCreated
		dateEdited
		channel
		parent
		votes {
			user {
				id
			}
		}
		user {
			id
			name
			avatar
		}
		files {
			id
			filename
			name
			type
			size
		}
	}
	comments(parent: $id) {
		id
		body
		dateCreated
		dateEdited
		user {
			id
			name
			avatar
		}
		votes {
			user {
				id
			}
		}
		files {
			id
			filename
			name
			type
			size
		}
	}
}`;

/*export const comments = gql`
comments(parent: $id) {
	id
	body
	dateCreated
	dateEdited
	user {
		id
		name
		avatar
	}
	votes {
		user {
			id
			name
		}
	}
	children {
		id
		body
		dateCreated
		dateEdited
		user {
			id
			name
			avatar
		}
		votes {
			user {
				id
				name
			}
		}
	}
	files {
		id
		filename
		name
		type
		size
	}
}`*/



/******************************
 * NOTES
 ******************************/

export const note = gql`
query note($id: ID!) {
  note(id: $id) {
    id
    body
    dateCreated
  }
}`;

export const notes = gql`{
	notes {
		id
		body
	}
}`;



/******************************
 * MAILS
 ******************************/

export const mail = gql`
query mail($id: ID!) {
  mail(id: $id) {
	id
	subject
	from
	to
	cc
    body
    dateSent
	unread
  }
}`;

export const mails = gql`{
	mails {
		id
		subject
		from
		unread
        dateSent
	}
}`;


// WEBPACK FOOTER //
// ./src/graphql/queries.js